"use strict";
/*
 todo: general:
 1. Popup
 2. Keyboard support
 3. custom-class attribute support
 4. date-disabled attribute support
 5. template-url attribute support
 */
var datepicker_component_1 = require('./datepicker/datepicker.component');
exports.DatePickerComponent = datepicker_component_1.DatePickerComponent;
var datepicker_module_1 = require('./datepicker/datepicker.module');
exports.DatepickerModule = datepicker_module_1.DatepickerModule;
var daypicker_component_1 = require('./datepicker/daypicker.component');
exports.DayPickerComponent = daypicker_component_1.DayPickerComponent;
var monthpicker_component_1 = require('./datepicker/monthpicker.component');
exports.MonthPickerComponent = monthpicker_component_1.MonthPickerComponent;
var yearpicker_component_1 = require('./datepicker/yearpicker.component');
exports.YearPickerComponent = yearpicker_component_1.YearPickerComponent;
var date_formatter_1 = require('./datepicker/date-formatter');
exports.DateFormatter = date_formatter_1.DateFormatter;



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/ng2-bootstrap/components/datepicker.js
// module id = ../../../../ng2-bootstrap/components/datepicker.js
// module chunks = 3